import React from 'react';

import { Typography } from '../../../Typography';
import { Box } from '../../../Box';
import { Icon } from '../../../Icon';
import { useStyles } from '../Preview.styles';
import { useIsDesktop } from '../../../hooks';

interface DownloadButtonProps {
  onClick?: () => Promise<void>;
  clickable?: boolean;
}

export const DownloadButton = ({ onClick, clickable }: DownloadButtonProps) => {
  const { classes } = useStyles();

  const isDesktop = useIsDesktop();

  if (clickable && !isDesktop)
    return <div className={classes.mobileCollapseBox} onClick={onClick} />;

  if (isDesktop)
    return (
      <div className={classes.collapseBox}>
        {onClick && (
          <Box className={classes.downloadButton} onClick={onClick}>
            <Typography variant="subtitle2" color="original.brand.primary">
              Скачать
            </Typography>
            <Icon
              name="download_outline"
              size="16"
              color="original.brand.primary"
            />
          </Box>
        )}
      </div>
    );

  return null;
};
